import React, { Component } from 'react';

export class About extends Component {
    static displayName = About.name;

    render() {
        return (
            <section className="page-section">
                <div className="container">
                    <div className="row" >
                        <div className="col-lg-12 text-center">
                            <h2 id="about" className="section-heading text-uppercase">About MyCoCreations</h2>
                            <h3 className="section-subheading text-muted">Pamper yourself, from head to toe.</h3>
                        </div>
                    </div>
                    <div className="row">
                        {/*    <div className="col-sm-4">
                            <div className="team-member">
                                <img className="mx-auto rounded-circle" src="img/team/1.jpg" alt="" />
                                <h4>Arminda Colón</h4>
                                <p className="text-muted">Founder / Lead Developer</p>
                                <ul className="list-inline social-buttons">
                                    <li className="list-inline-item">
                                        <a href="#twitter">
                                            <i className="fab fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="#fb">
                                            <i className="fab fa-facebook-f"></i>
                                        </a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="#linkedin">
                                            <i className="fab fa-linkedin-in"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div> */}
                        <div className="col-lg-12">
                            <p>MyCoCreations blossomed out of the need to protect my family. Once I began my journey of discovering the truth, I started inspecting the ingredient labels on the food I purchased. This led me to another truth. Our skin is alive, it breathes and absorbes what you put on it. What you put on your skin is just as important as what you put in it. I immediately began researching everything I could not pronounce or was not aware of.</p>
                            <p>The more I paid attention, the more I began noticing that the majority of products contained an extrodinary amount of unnecessary ingredients that are used to thicken, preserve, and make the product smell good. There is nothing wrong with trying to preserve something you may not use right away but what are those ingredients doing to your body? Allergies, skin rashes, cancers, tumors, acne and dry skin are just a few of the issues that are caused by these additives.</p>
                            <p>When you know better, you should do better. It is my belief that we must do everything in our power to consume only what nature has intended however the cost that is associated with eating or using organic products is always an area that get's special attention. In truth, something that is a raw material, something that can't be so easily obtained has more value and therefore you will pay more for quality products.  That should be a key indictor as to what level of quality the ingredients are.  I personally am willing to pay more for something that is better and will last longer.</p>
                            
                            <p>We strongly believe that we are creating a better world by providing healthy products that offer many benefits.</p>
                            
                            
                            <p>Thank you for taking the time to look at the products I am offering. If you have any questions or concerns please do not hesitate to contact me using the contact form or send an email directly to <a href="mailto:cocreator@mycocreations.com">cocreator@mycocreations.com</a></p>
                            </div>
                    </div>
                    <div className="row">

                        <div id="ssites" className="col-md-12" style={{ paddingTop: '100px' }}>
                            <ul className="timeline">
                                <li>
                                    <div className="timeline-image">
                                        <img className="rounded-circle img-fluid" src="img/about/tree.png" alt="" />
                                    </div>
                                    <div className="timeline-panel">
                                        <div className="timeline-heading">
                                            <h4 className="subheading">Organic Body Products</h4>
                                        </div>
                                        <div className="timeline-body">
                                            <p className="text-muted">Deodorant / Body Butter Available at <a href="http://shop.mycocreations.com">MyCoCreations Shop</a></p>
                                        </div>
                                    </div>
                                </li>
                                <li className="timeline-inverted">
                                    <div className="timeline-image">
                                        <img className="rounded-circle img-fluid" src="img/about/tree_i.png" alt="" />
                                    </div>
                                    <div className="timeline-panel">
                                        <div className="timeline-heading">
                                            <h4 className="subheading">Custom Handmade Clothing & Accessories</h4>
                                        </div>
                                        <div className="timeline-body">
                                            <p className="text-muted">Custom and Unique Items Available at <a href="http://boutique.mycocreations.com">MyCoCreations Boutique</a></p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="timeline-image">
                                        <img className="rounded-circle img-fluid" src="img/about/tree.png" alt="" />
                                    </div>
                                    <div className="timeline-panel">
                                        <div className="timeline-heading">
                                            <h4 className="subheading">Health Consultations / Organic Seeds </h4>
                                        </div>
                                        <div className="timeline-body">
                                            <p className="text-muted">Custom Food plans and Orangnic/NonGmo Seeds Available at <a href="http://www.roots-r-us.com">Roots R Us</a></p>
                                        </div>
                                    </div>
                                </li>
                                <li className="timeline-inverted">
                                    <div className="timeline-image">
                                        <a href="http://shop.mycocreations.com" alt="Shop MyCoCreations" target="_blank" rel="noopener noreferrer">
                                            <h4>Ready To
                                            <br />Experience the 
                                            <br />Difference?</h4>
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>

            </section>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/About.js